// extracted by mini-css-extract-plugin
module.exports = {"container":"e_8r","withContent":"e_9r","content":"e_-r","iconBox":"e_as","icon":"e_bs","hidden":"e_cs"};